// extracted by mini-css-extract-plugin
export default {"giftPointBody":"StationInfo_giftPointBody__5kRBC","okBtn":"StationInfo_okBtn__Qn6h-"};